const env = "development"; //development or local

let config = {
    host: env === "local" ? "http://localhost:3001" : "https://dvv.fulepu.com",
    host_ws: env === "local" ? "http://localhost:3000" : "https://dvv.fulepu.com",
    host_remote: "https://main.d12b3vjlhamtv7.amplifyapp.com",
    app_version: "v12052026"
}

export default config;